import moment from "moment";
import { useSelector } from "react-redux";
import { setPageLoader } from "../../Redux/features/utils.slice"
import { setProductsList  } from "../../Redux/features/productionLine.slice";
import { error, success } from "../../Helpers/notification";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import { setComponentLoader, setComponentReloader } from "../../Redux/features/utils.slice";
import { getFromLocalStorage, setToLocalStorage,moduleGenerateId } from "../../Helpers/helpers";
import { onPlantChange, getAllPlants, updatePlants, getSelectedLine } from "./plants.api";

const { productionLine,plants,shifts } = apiRoutes;

const createShift = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'shiftModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { line = null,machine=null } = current
    let { product } = body;
    let products = []
    let shiftSettings = []
    product.forEach((op) => {
        body.products.forEach((line) => {
            if (line == op.value)
                products.push({ product: op.label, id: op.value })
        })
    })
    let payloads = {
        create: {
            detailsAfter: {
                name: body.name,
                toValue: body.toValue,
                product: body.product,
                product: products,
                fromTime: body.fromTime,
                toTime: body.toTime,
            },
            action: 'Shift Created',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`,
            shiftSettings: [
                ...shiftSettings,
                {
                    name: body.name,
                    toValue: body.toValue,
                    product: body.product,
                    products: products,
                    fromTime: body.fromTime,
                    toTime: body.toTime,
                }], 
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createShiftRes = await postRequest({
            endPoint: shifts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createShiftRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, shiftSettings: payloads.update.shiftSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Shift Created.')
        }
    }
    catch (exc) {
        //notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'shiftModal', flag: false }))
}

const editShift = async (dispatch, body, current) => {

    dispatch(setComponentLoader({ component: 'shiftModal', flag: true }))
    let currentUser = getFromLocalStorage('user');
    let { shiftSettings } = current.plant
    let { product, rec, values } = body;
    let products = []
    product.forEach((op) => {
        values.lines.forEach((line) => {
            if (line.value) {
                if (line.value == op.value)
                    products.push({ product: op.label, id: op.value })
            }
            else {
                if (line == op.value)
                    products.push({ product: op.label, id: op.value })
            }
        })
    })
    const newShiftSettings = shiftSettings.filter(item => JSON.stringify(rec) !== JSON.stringify(item));
    let payloads = {
        create: {
            detailsBefore: { ...rec },
            detailsAfter: {
                name: values.name,
                toValue: values.toValue,
                product: values.product,
                products: products,
                fromTime: values.fromTime,
                toTime: values.toTime,
            },
            action: 'Shift Updated',
            email: currentUser?.username,
            hallName: current?.hall?.hallName,
            lineName: current?.line?.lineName,
            lineId: current?.line?.id,
            plantName: current?.plant?.plantName,
            plantId: current?.plant?._id,
            shiftName: current?.shift?.name,
            time: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            userId: "test132",
        },
        update: {
            shiftSettings: [
                ...newShiftSettings,
                {
                    name: body.name,
                    toValue: body.toValue,
                    product: body.product,
                    products: products,
                    fromTime: body.fromTime,
                    toTime: body.toTime,
                }],
            _id: current?.plant?._id,
            updatedAt: `${moment(new Date()).format("YYYY-MM-DDThh:mm:ss.ms")}Z`
        },
    }

    try {

        let updatePlantRes = await postRequest({
            endPoint: plants.update,
            body: payloads['update']
        })


        let createShiftRes = await postRequest({
            endPoint: shifts.create,
            body: payloads['create']
        })

        if (updatePlantRes.success === true && createShiftRes.success === true) {
            let { plant } = getFromLocalStorage('current')
            let plantToUpdate = { ...plant, shiftSettings: payloads.update.shiftSettings }
            updatePlants(plantToUpdate, plantToUpdate?._id, dispatch)
            success('Shift Updated.')
        }
    }
    catch (exc) {
       // notification.error(exc.message)
    }
    dispatch(setComponentLoader({ component: 'shiftModal', flag: false }))
}

const getProductsList = async (dispatch, current) => {

    //dispatch(setPageLoader({ page: 'lineOperator', flag: true }))

    //let { range } = selector;
    //let startDate = range[1] ? moment(range[1]).format(`YYYY-MM-DDThh:mm:ss.ms`) : ""
    //let endDate = range[0] ? moment(range[0]).format(`YYYY-MM-DDThh:mm:ss.ms`): ""
    let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
    let products = []
    const machineName = machine?.machineName || 'default';
    let response = await postRequest({
        endPoint: productionLine.product,
        body: { "conditions": {"plantId": plant?._id, "lineId": line?.id, "machine": machine!== 'default'? machineName : null, "attributes": undefined}}
        // `{%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName !== 'default' ? `%22${machineName}%22` : null}}&attributes=undefined`
    })
    //dispatch(setPageLoader({ page: 'lineOperator', flag: false }))
    //console.log({ response })
    if (response?.success && Array.isArray(response?.response))
    products = response.response
dispatch(setProductsList({ products }))
}
const createPlannedDowntime = async(plannedDowntime)=>{
    let id = plannedDowntime && plannedDowntime._id ? plannedDowntime._id : moduleGenerateId('plannedDowntime', plannedDowntime, plannedDowntime)
    plannedDowntime._id = id;
    let response = await postRequest({
        endPoint: productionLine.createPlannedDowntime,
        plannedDowntime
    })
    if (response.success === true) {
        success("Production Line Updated")
    }
}
const onDowntimeValuesSubmit = async (dispatch, body) => {

    dispatch(setPageLoader({ page: 'downtime', flag: true }))

    let response = await postRequest({
        endPoint: productionLine.update,
        body
    })
    dispatch(setPageLoader({ page: 'downtime', flag: false }))

    if (response.success === true) {
        success("Production Line Updated")
    let { selectedLine, lines = [] } = await getSelectedLine(body?.plantId, body?._id)
    let { plant = null, line = null, machine = null,hall=null,shift=null } = JSON.parse(localStorage.getItem('current'))
    selectedLine = selectedLine.filter(item => item._id == body._id);
    selectedLine = selectedLine[0];
    let machines = (selectedLine?.machines && selectedLine?.machines?.length) ? selectedLine?.machines : []
    
    let selectedMachine = machines?.length?machines.filter(item => item.machineName == machine?.machineName):null;
     selectedMachine = selectedMachine?.length ? selectedMachine[0]:null;
    const halls = JSON.parse(localStorage.getItem('halls'))
    const user = JSON.parse(localStorage.getItem('user'))
    setToLocalStorage(lines, 'lines')
    setToLocalStorage(machines, 'machines')

    let currentNew = {
        plant: plant,
        hall: hall,
        line: selectedLine,
        machine: selectedMachine,
        shift: shift
    }
    setToLocalStorage(currentNew, 'current')
    }


}

const updateTarget = (dispatch, data) => {
    console.log(data, 'im here')
}

export { getProductsList,onDowntimeValuesSubmit,createShift,editShift,createPlannedDowntime, updateTarget }
